import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import i18n from '@/libs/i18n'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useMaintenanceRecordList() {
  // Use toast
  const toast = useToast()

  const refMaintenanceRecordListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'chassisNumber', sortable: false , },
    { key: 'status', label: i18n.t('Status'), sortable: false },
    { key: 'startDate', sortable: false , },
    { key: 'endDate', sortable: false , },
    { key: 'maintenanceDuration', sortable: false},
    { key: 'odometer', sortable: false},
    { key: 'hourmeter', sortable: false},
    { key: 'actions' },
  ]

  const perPage = ref(10)
  const totalMaintenanceRecord = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref(null)
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const assetId = ref(null)


  const dataMeta = computed(() => {
    const localItemsCount = refMaintenanceRecordListTable.value ? refMaintenanceRecordListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalMaintenanceRecord.value,
    }
  })

  const refetchData = () => {
    refMaintenanceRecordListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, assetId], () => {
    refetchData()
  })

  const fetchAllMaintenanceRecord = (ctx, callback) => {

    store
      .dispatch('app-management/fetchMaintenances', {
        search: searchQuery.value,
        assetId: assetId.value,
        perPage: perPage.value,
        page: currentPage.value,
      })
      .then(response => {
        const maintenance = response.data.data;
        callback(maintenance)
        totalMaintenanceRecord.value = response.data.totalItems
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('Error fetching maintenance records list'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })


  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*


  return {
    fetchAllMaintenanceRecord,
    tableColumns,
    perPage,
    currentPage,
    totalMaintenanceRecord,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refMaintenanceRecordListTable,
    refetchData,
    assetId
  }
}
